export { default } from './PriceCard';



// WEBPACK FOOTER //
// ./src/components/molecules/PriceCard/index.js